// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { Action, Dispatch } from "redux";
import { ActionTypes } from "./actionTypes";
import { createAction, createPayloadAction, IPayloadAction } from "./actionCreators";

/**
 * Actions to be performed in relation to projects
 */
export default interface ICreateModelActions {
    updateuploadFilesCount(modelObject: any): Promise<void>;
    displayUploadingFilesStatus(): Promise<void>;
    setFilesCount(): Promise<void>;
    clearFilesCount(): Promise<void>;
}


export function setFilesCount(): (dispatch: Dispatch) => Promise<void> {
    return async (dispatch: Dispatch) => {
        dispatch(uploadFilesCount());
    };
}

export function updateuploadFilesCount(fileData?: any): (dispatch: Dispatch) => Promise<void> {
    return async (dispatch: Dispatch) => {
        dispatch(updateFileStatus(fileData));
    };
}

export function uploadingFilesStatus(): (dispatch: Dispatch) => Promise<void> {
    return async (dispatch: Dispatch) => {
        dispatch(displayUploadingFilesStatus("uploading files"));
    };
}

export function clearFilesCount(): (dispatch: Dispatch) => Promise<void> {
    return async (dispatch: Dispatch) => {
        dispatch(clearUploadedFilesCount());
    };
}

export interface IUploadedFilesStatus extends IPayloadAction<string, any> {
    type: ActionTypes.UPLOADED_FILE_STATUS;
}

export interface IUploadFilesCount extends Action<string> {
    type: ActionTypes.UPLOADED_FILE_COUNT_INCREMENT;
}

export interface IClearUploadFilesCount extends Action<string> {
    type: ActionTypes.CLEAR_UPLOADED_FILES_COUNT_SUCCESS;
}

export const updateFileStatus = createPayloadAction<IUploadedFilesStatus>(ActionTypes.UPLOADED_FILE_STATUS);
export const uploadFilesCount = createAction<IUploadFilesCount>(ActionTypes.UPLOADED_FILE_COUNT_INCREMENT);
export const clearUploadedFilesCount = createAction<IClearUploadFilesCount>(ActionTypes.CLEAR_UPLOADED_FILES_COUNT_SUCCESS);

export interface IUploadingFilesStatus extends IPayloadAction<string, any> {
    type: ActionTypes.UPLOADING_FILES_STATUS_SUCCESS;
}

export const displayUploadingFilesStatus = createPayloadAction<IUploadingFilesStatus>(ActionTypes.UPLOADING_FILES_STATUS_SUCCESS);

// UPLOADING_FILES_STATUS_SUCCESS

